import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Alert, Space, Typography } from 'antd';
import { fromNow, toNow, isAfterNow, isBeforeNow } from 'utils/date.util';
//import { withLDConsumer } from 'launchdarkly-react-client-sdk';
const { Text } = Typography;

export const AccountAlert = ({ flags }) => {

  const history = useHistory();
  const currentAccount = useSelector(s => s.account?.details);
  const [showTrialExpired, setShowTrialExpired] = useState(false)
  const [freeTrialExpiredDate, setFreeTrialExpiredDate] = useState(null)
  const [showFreeTrial, setShowFreeTrial] = useState(false)
  const [freeTrialTimeRemaining, setFreeTrialTimeRemaining] = useState(null)
  const [reviewRequired, setReviewRequired] = useState(false)
  const [inReview, setInReview] = useState(false)
  const [hasBillingIssue, setHasBillingIssue] = useState(false)

  useEffect(() => {
    if (currentAccount?.account_billing_status === 'trialing' &&
      !currentAccount?.billing_card_on_file &&
      isAfterNow(currentAccount?.trial_ends)
    ) {
      setShowFreeTrial(true)
      setFreeTrialTimeRemaining(fromNow(currentAccount?.trial_ends))
    }
    if (currentAccount?.account_billing_status === 'trialing' &&
      !currentAccount?.billing_card_on_file &&
      isBeforeNow(currentAccount?.trial_ends)
    ) {
      setShowTrialExpired(true)
      setFreeTrialExpiredDate(toNow(currentAccount?.trial_ends))
    }
  }, [currentAccount])

  /*
  useEffect(() => {
    if (currentAccount?.account_billing_status === 'trialing' &&
      !currentAccount?.billing_card_on_file &&
      isAfterNow(currentAccount?.trial_ends)
    ) {
      setShowFreeTrial(true)
      setFreeTrialTimeRemaining(fromNow(currentAccount?.trial_ends))
    }
    if (currentAccount?.account_review_status === 'review-required') {
      setReviewRequired(true)
    }
    if (currentAccount?.account_review_status === 'in-review') {
      setInReview(true)
    }
    if (currentAccount?.account_billing_status === 'failed') {
      setHasBillingIssue(true)
    }
  }, [currentAccount])

  if (!showFreeTrial && !reviewRequired && !hasBillingIssue) {
    return null
  }

  const addBilling = async () => {
    history.push('/settings/billing')
  }
  const startReview = async () => {
    // TODO: Show Start Review Modal
  }
  const contactUs = async () => {
    // TODO: Show Contact Us Modal
  }

  if(!flags.accountAlerts) {
    return null
  }
  */
  // TODO: Add Trial Expired Warning
  // Your trial has expired and you are limited to reader access. Select a plan or extend your trial.

  const addBilling = async () => {
    history.push('/settings/billing')
  }
  const selectPlan = async () => {
    history.push('/settings/billing')
  }

  return (
    <>
      {showFreeTrial &&
        <Alert
          className='app-account-alert'
          type="info"
          message={<Text strong>You have {freeTrialTimeRemaining} remaining of your PushPulse trial. Add your billing details to continue access after your trial.</Text>}
          banner
          closeText="Dismiss"
          action={
            <Button
              onClick={() => selectPlan()}
              size="small" type="primary">
              Add Billing Details
            </Button>
          }
        />
      }
      {showTrialExpired &&
        <Alert
          className='app-account-alert'
          type="error"
          message={<Text strong>Your trial has expired {freeTrialExpiredDate} ago and your functionality has been limited. Your organzation is not currently able to send or receive notifications.</Text>}
          banner
          closeText="Dismiss"
          action={
            <Button
              onClick={() => selectPlan()}
              size="small" type="primary">
              Select a Plan
            </Button>
          }
        />
      }
      {hasBillingIssue &&
        <Alert
          className='app-account-alert'
          type="error"
          message={<Text strong>There was an error processing your payment. Update your billing details to continue access.</Text>}
          banner
          closeText="Dismiss"
          action={
            <Button
              onClick={() => addBilling()}
              size="small" type="primary">
              Update Billing Details
            </Button>
          }
        />
      }
      {(reviewRequired && !inReview) &&
        <Alert
          className='app-account-alert'
          type="warning"
          message={<Text strong>Account Review Required. Please Complete the Form to Start Your Review.</Text>}
          banner
          closeText="Dismiss"
          action={
            <Button
              onClick={() => startReview()}
              size="small" type="primary">
              Start Review
            </Button>
          }
        />
      }
      {(reviewRequired && inReview) &&
        <Alert
          className='app-account-alert'
          type="warning"
          message={<Text strong>Your account is under review. Contact us with any questions.</Text>}
          banner
          closeText="Dismiss"
          action={
            <Button
              onClick={() => contactUs()}
              size="small" type="primary">
              Contact Us
            </Button>
          }
        />
      }

    </>
  )
}

//export default withLDConsumer()(AccountAlert);
export default AccountAlert;
